import {atom, selectorFamily, useSetRecoilState} from 'recoil';
import {ToastHelpers} from '../../../shared/helpers/toastHelpers';
import {serialize} from '../../../shared/utils/serialize-query-params';
import {api, Pageable} from '../../api';
import {createQuery} from '../../lib';

const {getContractsCidDocuments} = api.contracts;

type Params = {
  cid: Parameters<typeof getContractsCidDocuments>[0];
  page?: Pageable['page'];
  size?: Pageable['size'];
  sort?: Pageable['sort'];
};

const getContractsCidDocumentsRefresh = atom<number>({
  key: 'getContractsCidDocumentsRefresh',
  default: 0,
});

const getContractsCidDocumentsQuery = selectorFamily({
  key: 'getContractsCidDocuments',
  get({cid, ...pageable}: Params) {
    return async ({get}) => {
      get(getContractsCidDocumentsRefresh);
      try {
        const {data} = await getContractsCidDocuments(cid, {pageable}, {paramsSerializer: {serialize}});
        return data;
      } catch (e) {
        ToastHelpers.error(e);
        throw e;
      }
    };
  },
});

export const useGetContractsCidDocumentsRefresh = () => {
  const setRefresh = useSetRecoilState(getContractsCidDocumentsRefresh);
  return () => setRefresh((prev) => prev + 1);
};

export const useGetContractsCidDocumentsQuery = createQuery(
  getContractsCidDocumentsQuery,
  getContractsCidDocumentsRefresh,
);
